Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(
      this.currentTime > 0 &&
      !this.paused &&
      !this.ended &&
      this.readyState > 2
    );
  },
});

/**
 * Get Pause button elements
 * @param {String} [videoId] - Optional: The ID of the associated video
 * @returns
 */
function getPauseButtons(videoId) {
  if (typeof videoId === 'undefined') {
    return document.querySelectorAll('.js-vid-pause-btn');
  } else {
    return document.querySelectorAll(
      '.js-vid-pause-btn[aria-controls="' + videoId + '"]'
    );
  }
}

function setPauseButtonsState(state, videoId) {
  // Get all pause buttons for this video
  const buttons = getPauseButtons(videoId);

  if (state === 'playing') {
    buttons.forEach((el) => {
      el.dataset.playing = 'true';
      el.setAttribute('aria-label', 'Pause video');
    });
  } else if (state === 'paused') {
    buttons.forEach((el) => {
      el.dataset.playing = 'false';
      el.setAttribute('aria-label', 'Play video');
    });
  }
}

/**
 * Set video playing state
 *
 * @param {String} state - playing|paused
 * @param {Element} video - Video element to control
 * @param {String} videoId - The ID of the video
 */
function setVideoState(state, video, videoId) {
  if (state === 'playing') {
    video.play();
  } else if (state === 'paused') {
    video.pause();
  }

  setPauseButtonsState(state, videoId);
}

function setupPauseButtons() {
  const buttons = getPauseButtons();

  buttons.forEach((el) => {
    // Get connected video
    const videoId = el.getAttribute('aria-controls');
    const video = document.querySelector('#' + videoId);

    el.addEventListener('click', function () {
      // Get current play state
      const buttonPlaying = el.dataset.playing;

      if (buttonPlaying === 'true') {
        setVideoState('paused', video, videoId);
      } else {
        setVideoState('playing', video, videoId);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupPauseButtons();
});
